$(document).on("turbolinks:load", () => {
    // 予約用IDインポート画面csvアップロード処理
    var check_status_for_csv_import = function(){
        if(document.URL.match("/csv_upload_for_users/new")){
            update_screen_for_csv_import("/csv_upload_for_users/check_status")
        }
    };
    // 3秒間隔で実行
    setInterval(check_status_for_csv_import, 3000);
 
});
 
function update_screen_for_csv_import(url){
    $.ajax(
        {url: url,
        type: "GET"
        }
    )
    .done(function(data){

        // アップロード処理完了、処理中
        if(data["per_import"] == undefined){
            // フォームを表示
            $(".csv-import--display").show()

            // アップロードステータス表示削除
            $(".csv-import--no-display").remove()

            // 前回インポート情報、全インポート件数情報更新
            $(".import-info").children().remove()
            var html = `<div>
                        <p>
                        前回インポート日時: ${data["imported_at"] == undefined ? ``: data["imported_at"]}
                        </p>
                        <p>
                        前回インポート件数: ${data["last_csv_upload"] == undefined ? ``: data["last_csv_upload"]["count_imported"]} (${data["last_csv_upload"] == undefined ? ``: data["last_csv_upload"]["count_csv_all"]}件中${data["last_csv_upload"] == undefined ? ``: data["last_csv_upload"]["count_imported"]}件 インポート成功)
                        </p>
                        <p>
                        全インポート件数: ${data["count"]}
                        </p>
                        </div>`
            $(".import-info").append(html)

        }else{
            // ファイルアップロード処理の部分を非表示
            $(".csv-import--display").hide()

            // アップロードステータス表示切り替え
            $(".csv-import--no-display").remove()
            var html = `<div class='csv-import--no-display'>
                        <div class='card'>
                        前回のインポート分の処理を行っています。
                        現在${data["per_import"]}%完了しています。
                        </div>
                        <div class='footer-button--block'>
                        <a class="button button-primary" data-confirm="インポート処理を中断します。本当に中断してよろしいですか？" href="/csv_upload_for_users/cancel_process">処理を中断する</a>
                        </div>
                        </div>
                        </div>`
            $(".check_status--csv_upload").append(html)
        }
        
    })    
}